<div [ngSwitch]="tipoBtn" class="w-auto d-inline-block">
    <button mat-flat-button [color]="color" [disabled]="bloquear" [matMenuTriggerFor]="menu" *ngSwitchCase="'flat'">
        <ng-content select="[btnTxtFlat]"></ng-content>
    </button>
    <button mat-stroked-button [color]="color" [disabled]="bloquear" [matMenuTriggerFor]="menu" *ngSwitchCase="'stroked'">
        <ng-content select="[btnTxtStroked]"></ng-content>
    </button>
    <button class="btn-icono" mat-icon-button [color]="color" [disabled]="bloquear" [matMenuTriggerFor]="menu" *ngSwitchCase="'icon'">
        <mat-icon>
            {{icono}}
        </mat-icon>
      </button>
    <button mat-button [color]="color" [matMenuTriggerFor]="menu" *ngSwitchDefault>
        <ng-content select="[btnTxt]"></ng-content>
    </button>
</div>

<mat-menu #menu="matMenu" class="menu-confirmacion" [hasBackdrop]="true" backdropClass="backgroud-menu-confirmar">
    <div class="row mx-0 justify-content-end">
        <div class="col-12" style="font-size: 14px;">
            <ng-content select="[pregunta]"></ng-content>
        </div>
        <div class="d-flex justify-content-around">
            <div class="col-md-auto">
                <button class="mat-button-sm" mat-stroked-button color="warn" (click)="rechazar.emit(true)">
                {{txtBtnRechazar}}
            </button>
            </div>
            <div class="col-md-auto">
                <button class="mat-button-sm" mat-flat-button color="warn" (click)="confirmar.emit(true)">
                {{txtBtnConfirmar}}
            </button>
            </div>
        </div>
    </div>
</mat-menu>